import Image from 'next/image';
import React from 'react';
import classes from './styles.module.scss';
import clsx from 'clsx';

function BlogImage(props) {
  const { className, src, alt, caption, ...rest } = props;
  return (
    <div className={clsx(classes.imageContainer, className?.imageContainer)}>
      <Image
        src={src}
        alt={alt}
        fill
        {...rest}
        className={clsx(classes.image, className?.image)}
      />
      {caption && <p>{caption}</p>}
    </div>
  );
}

export default BlogImage;
